module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "open": _vm.open,
      "size": "lg"
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Search for HOD")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "text-center col-md-4 col-md-offset-4 padding-bottom-20"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw fa-5x"
  })]) : (!_vm.loading && _vm.hods.length) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-xs-8"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-info-sign"
  }), _vm._v(" Search for your HOD.\n        ")]), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-4",
    attrs: {
      "name": "filterText",
      "label": "Search"
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  })], 1), _vm._v(" "), (_vm.filteredHods.length) ? _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("First Name")]), _vm._v(" "), _c('td', [_vm._v("Last Name")]), _vm._v(" "), _c('td', [_vm._v("Training Institution")]), _vm._v(" "), _c('td', [_vm._v("Speciality")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredHods), function(hod) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(hod.user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hod.user.surname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hod.trainingInstitution))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hod.speciality))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      on: {
        "click": function($event) {
          return _vm.select(hod)
        }
      }
    }, [_vm._v("Select")])])])
  }), 0)]) : _c('p', {
    staticClass: "text-center padding-bottom-20"
  }, [_vm._v("\n        No HOD's found\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n        Can't find the HOD you are looking for? Invite them to join.\n      ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.invite($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    staticClass: "col-xs-6",
    attrs: {
      "name": "hodEmail",
      "label": "Email Address",
      "validation": _vm.$v.hodInvite.emailAddress
    },
    model: {
      value: (_vm.hodInvite.emailAddress),
      callback: function($$v) {
        _vm.$set(_vm.hodInvite, "emailAddress", $$v)
      },
      expression: "hodInvite.emailAddress"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-6",
    attrs: {
      "name": "hodName",
      "label": "Name",
      "validation": _vm.$v.hodInvite.name
    },
    model: {
      value: (_vm.hodInvite.name),
      callback: function($$v) {
        _vm.$set(_vm.hodInvite, "name", $$v)
      },
      expression: "hodInvite.name"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Invite")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f1f8ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/modals/HodSearchModal.vue
// module id = 654
// module chunks = 5